export default {"src":"/_next/static/media/fantom.1e444dad.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};